interface ExitConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ExitConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
}: ExitConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center px-6">
      <div className="absolute inset-0 bg-foreground-950/40" onClick={onCancel} />
      <div className="relative w-full max-w-[320px] bg-white rounded-2xl px-6 py-6 animate-pop-in">
        <p className="text-lg font-bold text-foreground-950 text-center mb-1.5">
          게임을 종료할까요?
        </p>
        <p className="text-sm text-foreground-500 text-center mb-6">
          지금까지의 진행 내용이 저장되지 않습니다.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 h-12 rounded-xl bg-background-100 border border-background-300 text-foreground-700 font-semibold text-base whitespace-nowrap
              active:scale-[0.99] transition-transform duration-150 hover:bg-background-200 cursor-pointer"
          >
            계속하기
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 h-12 rounded-xl bg-primary-600 text-white font-semibold text-base whitespace-nowrap
              active:scale-[0.99] transition-transform duration-150 hover:bg-primary-700 cursor-pointer"
          >
            종료하기
          </button>
        </div>
      </div>
    </div>
  );
}